export function attributeNameToPropertyName(attributeName: string) {
  return attributeName
    .replace(/^(x|data)[-_:]/i, '')
    .replace(/[-_:](.)/g, (x, chr: string) => chr.toUpperCase());
}

export function parseAttributeValue(value: string | null): unknown {
  if (!value) {
    return null;
  }

  if (value === 'true') return true;
  if (value === 'false') return false;

  // Support attribute values with newlines
  const cleanValue = value.replace(/[\n\r]/g, '');
  let newValue: unknown = cleanValue;

  const pointerRegexp = /^{.*?}$/i;
  const jsonRegexp = /^{{2}.*}{2}$/;
  const jsonArrayRegexp = /^{\[.*\]}$/;

  const pointerMatches = cleanValue.match(pointerRegexp);
  const jsonMatches =
    cleanValue.match(jsonRegexp) || cleanValue.match(jsonArrayRegexp);

  if (jsonMatches) {
    newValue = JSON.parse(jsonMatches[0].replace(/^{|}$/g, ''));
  } else if (pointerMatches) {
    /* eslint-disable no-eval */
    newValue = eval(pointerMatches[0].replace(/[{}]/g, ''));
  }

  return newValue;
}

export function getProps(node: Element) {
  const props: Record<string, unknown> = {};

  for (let i = 0; i < node.attributes.length; i++) {
    const attribute = node.attributes[i];
    const name = attributeNameToPropertyName(attribute.name);
    props[name] = parseAttributeValue(attribute.value);
  }

  props.container = node;

  return props;
}

export function getChildren(node: Node) {
  const fragment = document.createDocumentFragment();
  if (node.childNodes.length) {
    Array.prototype.forEach.call(node.childNodes, (child: Node) => {
      fragment.appendChild(child.cloneNode(true));
    });
  }
  return fragment;
}

export default {
  attributeNameToPropertyName,
  parseAttributeValue,
  getProps,
  getChildren,
};
